import { IVaultCreditAccountInput } from 'generated/graphql-gateway';
import { StatusType, dataDogLogger } from 'utils/datadog';
import { encryptCreditCardChase } from 'utils/encryption';
import { getConfigValue } from 'utils/environment';

import { LOG_MESSAGE_ADD_CREDIT_ACCOUNT_FAILED, RBIPaymentError } from './constants';
import { ITokenizeCardGraphQl } from './types';

export const tokenizeCardGraphQl: ITokenizeCardGraphQl = async (
  reshapedPaymentValues,
  vaultCreditAccountMutation
): Promise<string | null> => {
  if (!reshapedPaymentValues.expiryDate) {
    throw new Error('Expiry Date is required');
  }
  if (!reshapedPaymentValues.securityCode) {
    throw new Error('Security Code is required');
  }

  const publicKey = getConfigValue('tokenEx').publicKey;

  // CC details encryption for TokenEx
  const encryptedCredit = await encryptCreditCardChase({
    credit: reshapedPaymentValues,
    publicKey,
  });

  const { cardNumber, expiryDate, securityCode, cardType } = encryptedCredit;

  const input: IVaultCreditAccountInput = {
    creditCard: {
      cardNumber,
      securityCode,
      expirationMonth: expiryDate.month,
      expirationYear: expiryDate.year,
      cardType,
    },
  };

  try {
    const mutationResult = await vaultCreditAccountMutation({ variables: { input } });
    const vaultedCardId = mutationResult.data?.vaultCreditAccount.id;
    if (vaultedCardId) {
      return vaultedCardId;
    }
    throw new Error('Error Vaulting Credit Card'); // If we don't receive a vaultedCardId throw an error
  } catch (err) {
    dataDogLogger({
      message: LOG_MESSAGE_ADD_CREDIT_ACCOUNT_FAILED,
      context: {
        error: err,
        errorReason: 'UNKNOWN',
        errorCode: 'UNKNOWN',
        reason: RBIPaymentError.TOKENIZATION_FAILURE,
      },
      status: StatusType.error,
    });
    throw err;
  }
};
